import React, { useRef, useEffect } from "react";
import PropTypes from "prop-types";
import styles from  "./style.css";

import CarDetailStickyViewRevamp from "../car-detail-sticky-view-revamp";
const HelloARView = ({
    iframeUrl,
    galleryProps = {},
    onClose = () => {},
    onClickCallback = () => {},
    isWishlisted,
    onWishlistClick = () => {},
    comingSoon = false,
    ctaProps = {},
    content,
    onClickNotifyIcon
}) => {
    // const { exterior360Images, interior360Images, mediaSource } = content  || {};
    // const { exterior360, interior360 } = s20DummyData || {};
    const { subActiveTab = "", imageName = ""} = galleryProps  || {};
    const spinRef = useRef();
    useEffect(() => {
        const spinRefContainer = (spinRef && spinRef.current) || window;
        const myConfObj = {
            iframeMouseOver: false
        };

        window.addEventListener("blur", () => {
            if (myConfObj.iframeMouseOver) {
                onClickCallback();
            }
        });
        spinRefContainer.addEventListener("mouseover", () => {
            myConfObj.iframeMouseOver = true;
            window.focus();
        });
        spinRefContainer.addEventListener("mouseout", () => {
            myConfObj.iframeMouseOver = false;
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    iframeUrl = `${iframeUrl}${subActiveTab ? `&tab=${subActiveTab}` : ""}${imageName ? `&image_name=${imageName}` : ""}&gid=${process.env.GA_ID}`;
    return (
        <React.Fragment>
            {/* <div
                styleName="styles.header">
                <div onClick={onClose}>
                    <ArrowIcon rotateBy={180}/>
                    <span styleName={"styles.heading"}>Back to details</span>
                </div>
                <div styleName={"styles.buttonWrap"}>
                    <Button
                        text={ctaProps.text}
                        disabled={ctaProps.disabled}
                        isLoading={ctaProps.isLoading}
                        onClick={() => ctaProps.action(AU_DESKTOP_EVENTS.CAR_GALLERY_VIEW)}
                    />
                    {comingSoon ? null : <div >
                        <img
                            src={isWishlisted ? wishlistIconFilled : wishlistIcon}
                            alt="wishlist"
                            onClick={(e) => onWishlistClick(e, "car_gallery_view")}
                        />
                    </div>}
                </div>
            </div> */}
            <CarDetailStickyViewRevamp
                content={content}
                onClose={onClose}
                ctaProps={ctaProps}
                onWishlistClick={onWishlistClick}
                isWishlisted={isWishlisted}
                comingSoon={comingSoon}
                onClickNotifyIcon={onClickNotifyIcon}
                source="gallery"
            />
            <div className="container" styleName="styles.rotateWrapper">
                {/* {mediaSource === MEDIA_SOURCE.s20 ? <safecam-360-viewer
                    interior360={JSON.stringify(interior360Images)}
                    exterior360={JSON.stringify(exterior360Images)}
                    // galleryData={JSON.stringify(galleryData)}
                /> : */}
                <div className="row">
                    <iframe ref={spinRef} styleName="styles.spincarIframe" src={iframeUrl} height="100%" width="100%"/>
                </div>
                {/* } */}
            </div>
        </React.Fragment>
    );
};

HelloARView.propTypes = {
    iframeUrl: PropTypes.string,
    text: PropTypes.string,
    galleryProps: PropTypes.object,
    onClose: PropTypes.func,
    content: PropTypes.object,
    onClickCallback: PropTypes.func,
    comingSoon: PropTypes.bool,
    ctaProps: PropTypes.object,
    isWishlisted: PropTypes.bool,
    onWishlistClick: PropTypes.func,
    onClickNotifyIcon: PropTypes.func
};

export default HelloARView;
